import { render } from "./BlueshiftLogo.vue?vue&type=template&id=b63751aa"
const script = {}

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__